<template>
  <ga-notifications-base :position="position" />
</template>

<script src="./notifications.script.js" />
